<template>
  <rest-page :fetch-endpoint="fetchEndpoint">
    <el-dialog
      :title="$t('Profiles_Overview_Title_EditCategorisedAttributes')"
      :visible.sync="visible"
      width="50%"
      :before-close="handleClose"
      :modal-append-to-body="false"
      :append-to-body="true"
      destroy-on-close
    >
      <el-row>
        <table class="attrs-table">
          <draggable v-model="data" tag="tbody">
            <tr v-for="(item, index) in data">
              <td>
                <featured-attributes-section
                  :key="index"
                  :data="item"
                  :category-id="categoryId"
                  :already-selected-attribute-names="allSelectedAttributeNames"
                  @delete-section="deleteSection(index)"
                  @delete-attr="deleteAttr($event, index)"
                  @add-attr="addAttr($event, index)"
                />
              </td>
            </tr>
          </draggable>
        </table>
      </el-row>
      <el-row>
        <el-col class="add-section">
          <el-link
            @click="addSection()"
            type="primary"
            icon="el-icon-circle-plus-outline"
          >
            {{ $t('Profiles_Overview_Text_AddDataSection') }}
          </el-link>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" plain @click="handleClose">
          {{ $t('Profiles_Overview_Button_Cancel') }}
        </el-button>
        <el-button type="primary" @click="save" :loading="loading">
          {{ $t('Profiles_Overview_Button_Save') }}
        </el-button>
      </span>
    </el-dialog>
  </rest-page>
</template>

<script>
import RestPage from '@/common/components/rest/RestPage'
import FeaturedAttributesSection from '@/modules/profiles/components/categorised-attributes/FeaturedAttributesSection'
import draggable from 'vuedraggable'
import { projectEndpoint, projectUrl } from '@/core/helpers'
import RestApi from '@/core/services/RestApi'
import _ from 'lodash'
export default {
  name: 'FeaturedAttributesDialog',

  components: {
    RestPage,
    FeaturedAttributesSection,
    draggable
  },

  data() {
    return {
      data: [],
      initialDataState: [],
      loading: false
    }
  },

  props: {
    afterSaveAction: {
      type: Function,
      default: () => {}
    },

    visible: {
      type: Boolean,
      required: true
    },

    profileId: {
      type: String,
      required: true
    },

    categoryId: {
      type: Number,
      required: true
    }
  },

  methods: {
    addSection() {
      this.data.push({
        group_name: this.$t('Profiles_Overview_Text_NewSection'),
        group_order: this.data.length,
        category_id: this.categoryId,
        attributes: []
      })
    },

    deleteSection(index) {
      this.data.splice(index, 1)
    },

    addAttr(attr, index) {
      if (this.data[index]) {
        this.data[index].attributes.push(attr)
      }
    },

    deleteAttr(obj, index) {
      let thisIndex = this.data[index].attributes.findIndex(
        item => item === obj
      )
      this.data[index].attributes.splice(thisIndex, 1)
    },

    handleClose() {
      if (this.hasBeenModified) {
        this.confirmClose()
      } else {
        this.$emit('update:visible', false)
      }
    },

    confirmClose() {
      this.$msgbox({
        title: this.$t('Profiles_DialogClose_Title'),
        message: this.$t('Profiles_DialogClose_Prompt'),
        showCancelButton: true,
        confirmButtonText: this.$t('Profiles_DialogClose_Button_Confirm'),
        cancelButtonText: this.$t('Profiles_DialogClose_Button_Cancel'),
        center: true
      }).then(() => {
        this.$emit('update:visible', false)
      })
    },

    save() {
      this.loading = true

      const payload = this.data.map((item, index) => {
        return {
          ...item,
          group_order: index,
          attributes: (item.attributes || []).map(attr =>
            typeof attr === 'string' ? attr : attr.name
          )
        }
      })

      RestApi.put(projectUrl(`featured-attributes`), {
        items: payload,
        category: this.categoryId
      })
        .then(() => {
          this.loading = false
          this.$message({
            message: this.$t(
              'Profiles_Message_FeaturedAttributesUpdatedSuccessMessage'
            ),
            type: 'success'
          })
          this.$emit('update:visible', false)
          this.$emit('updated', this.data)
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
          this.loading = false
        })
    }
  },

  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `categorised-attributes?category_id=${this.categoryId}`,
        handler: data => {
          this.data = data
          this.data.sort((a, b) => a.group_order - b.group_order)
          this.initialDataState = _.cloneDeep(this.data)
        }
      })
    },

    allSelectedAttributeNames() {
      const seen = new Set()
      for (const item of this.data || []) {
        for (const attr of item.attributes || []) {
          const name =
            typeof attr === 'object' && attr !== null
              ? attr.name || attr.display_name
              : attr
          if (name != null) {
            seen.add(name)
          }
        }
      }
      return Array.from(seen)
    },

    hasBeenModified() {
      return !_.isEqual(this.initialDataState, this.data)
    }
  }
}
</script>

<style scoped lang="scss">
.attrs-table {
  width: 100%;
}
.add-section {
  margin: 8px 0;
  padding: 16px;
  background: #f8fafc;
  border: 1px solid #dbdee7;
  border-radius: 4px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/modules/profiles/components/categorised-attributes/FeaturedAttributesDialog.vue